import { render, staticRenderFns } from "./SkinSensitivityTemplate.vue?vue&type=template&id=c2d8063c"
import script from "./SkinSensitivityTemplate.vue?vue&type=script&lang=js"
export * from "./SkinSensitivityTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports